import {
  ApplicationConfig,
  ErrorHandler,
  provideZoneChangeDetection,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
  HttpClient,
} from '@angular/common/http';
import { loadingInterceptor } from './shared/interceptors/loading-interceptor';
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { achievementInterceptor } from './shared/interceptors/achievement.interceptor';
import { provideAuth0 } from '@auth0/auth0-angular';
import { environment } from '../environments/environment';
import { GlobalErrorHandlerService } from './shared/services/global-error-handler/global-error-handler.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Factory function for TranslateHttpLoader
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        loadingInterceptor,
        authInterceptor,
        achievementInterceptor,
      ]),
    ),
    provideAuth0({
      domain: environment.auth.domain,
      clientId:
        localStorage.getItem('auth0_client_id') || environment.auth.clientId,
      authorizationParams: {
        redirect_uri: `${window.location.origin}/login-callback`,
      },
    }),
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService,
    },
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
        defaultLanguage: 'en',
      }),
    ),
  ],
};
